import { computed } from 'vue';
import { useRouter } from 'vue-router';
import useAuthStore from '@/store/modules/auth.js';
import { routeIndexGroupNames } from '@/constants/route.js';

const usePageNavigationHook = () => {
  const router = useRouter();

  const authStore = useAuthStore();

  const indexRouteName = computed(() => authStore.isUserAuthenticated ? routeIndexGroupNames.AUTH : routeIndexGroupNames.VISITOR);
  const hasBackRoute = computed(() => !!router.options.history.state.back);

  const redirectBack = () => {
    router.back();
  };

  const redirectTo = (routeName, options = {}) => {
    router.push({ name: routeName, ...options });
  };

  const redirectToHomePage = () => {
    redirectTo('Home');
  };

  const redirectToStorePage = () => {
    redirectTo('Store');
  };

  return {
    indexRouteName,
    hasBackRoute,
    redirectBack,
    redirectTo,
    redirectToHomePage,
    redirectToStorePage,
  };
};

export default usePageNavigationHook;
